import { useQuery } from '@tanstack/react-query';
import { adminOrgsApi, AdminOrgsListParams } from '../../services/api/adminOrgs';

export const useAdminOrgs = (params?: AdminOrgsListParams) => {
  return useQuery({
    queryKey: ['admin', 'orgs', params],
    queryFn: () => adminOrgsApi.list(params),
    // Refresh every minute so the trial countdown stays roughly fresh while
    // the operator leaves the tab open.
    refetchInterval: 60_000,
    staleTime: 30_000,
  });
};
